module.exports = __webpack_public_path__ + "img/genicon-icons8-heart-filled.13d56496.svg";